// extracted by mini-css-extract-plugin
module.exports = {"container":"DeleteAccountView_container__oYZXl","sub":"DeleteAccountView_sub__V1pHC","deleteButton":"DeleteAccountView_deleteButton__bx9wC"};